import { defaultAgreementStatusSelectorFilter } from '~/business-logic/agreementStatusSelectorFilter';
import { fullName, sortAlphabetically } from '~/infra/utils';
import { timeModel } from '~/models';
import { dropTabScopedParams, hasTabScopedParams } from '../AgreementMinisite/AgreementMinisiteTopBar/AgreementMinisiteTopBar.utils';
import img1 from './img/globalBillingHubPreview1.png';
import img2 from './img/globalBillingHubPreview2.png';
export const billingHubHeaderTextsPath = 'billing.globalHub.header';
export function toAdHocOptions(adHocRelationships, headerTexts) {
    const needsContactDisambiguation = adHocRelationships.length > 1;
    return adHocRelationships.map((param)=>{
        let { id, buyerName } = param;
        return {
            id,
            text: buyerName == null || !needsContactDisambiguation ? headerTexts.invoicesWithoutAgreement() : headerTexts.invoicesWithoutAgreementForContact({
                contact: buyerName
            })
        };
    });
}
export function getGroupedAgreementOptions(agreements, clientId) {
    if (!clientId) return {
        agreements: [],
        adHocRelationships: []
    };
    return partitionBillable(agreements.filter((a)=>a.customer.id === clientId));
}
export function getBillableGroupedOptions(summaries) {
    return partitionBillable(summaries);
}
export function getCrmClientOptions(clients, billableClientIds) {
    const options = clients.filter((c)=>!c.isSample() && billableClientIds.has(c.clientId())).map((c)=>({
            id: c.clientId(),
            text: c.name()
        }));
    return sortAlphabetically(options, 'text', {
        ascending: true,
        ignoreCase: true
    });
}
export function getBillableClientIds(summaries) {
    return new Set(summaries.filter(isBillableSummary).map((a)=>a.customer.id));
}
function partitionBillable(candidates) {
    const billable = candidates.filter(isBillableSummary);
    const agreements = billable.filter((a)=>a.agreementStatusV2 != null).sort((a, b)=>{
        var _ref, _ref1;
        var _a_effectiveDate, _b_effectiveDate;
        return ((_ref = (_a_effectiveDate = a.effectiveDate) === null || _a_effectiveDate === void 0 ? void 0 : _a_effectiveDate.getTime()) !== null && _ref !== void 0 ? _ref : 0) - ((_ref1 = (_b_effectiveDate = b.effectiveDate) === null || _b_effectiveDate === void 0 ? void 0 : _b_effectiveDate.getTime()) !== null && _ref1 !== void 0 ? _ref1 : 0);
    }).map((a)=>({
            id: a.id,
            text: a.title || (a.effectiveDate ? "unnamed (from ".concat(timeModel.formatDate(a.effectiveDate), ")") : 'unnamed')
        }));
    const adHocRelationships = billable.filter((a)=>a.agreementStatusV2 == null).map((a)=>({
            id: a.id,
            buyerName: adHocBuyerName(a)
        }));
    return {
        agreements,
        adHocRelationships
    };
}
function adHocBuyerName(summary) {
    var _fullName;
    const buyer = summary.buyer;
    if (buyer == null) return null;
    return (_fullName = fullName(buyer.firstName, buyer.lastName)) !== null && _fullName !== void 0 ? _fullName : buyer.email;
}
function isBillableSummary(a) {
    if (a.isSample) return false;
    if (a.agreementStatusV2 == null) return true;
    return defaultAgreementStatusSelectorFilter.includes(a.agreementStatusV2);
}
export function getDefaultRelationshipId(agreementOptions) {
    return agreementOptions[0] ? agreementOptions[0].id : '';
}
export const buildSeeWhatItsLikeSteps = (texts)=>[
        {
            title: texts.emptyTitle1(),
            subtitle: texts.emptySubtitle1(),
            image: {
                src: img1,
                width: 850,
                height: 497
            }
        },
        {
            title: texts.emptyTitle2(),
            subtitle: texts.emptySubtitle2(),
            image: {
                src: img2,
                width: 850,
                height: 505
            }
        }
    ];
export const resolveBillingHubEntryNavigation = (param)=>{
    let { pathname, search, basePath, knownTabUrls, defaultTabUrl } = param;
    const currentSegment = pathname.slice(basePath.length + 1).split('/')[0];
    const scopedSearch = dropTabScopedParams(search);
    if (!currentSegment || !knownTabUrls.includes(currentSegment)) {
        return "".concat(basePath, "/").concat(defaultTabUrl).concat(scopedSearch);
    }
    if (hasTabScopedParams(search)) {
        return "".concat(pathname).concat(scopedSearch);
    }
    return null;
};
